import isEmail from 'validator/es/lib/isEmail';
import isNumeric from 'validator/es/lib/isNumeric';
import isLength from 'validator/es/lib/isLength';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import { isEmpty, isString, capitalize, deburr, padStart, trim } from 'lodash';

const schema = {
  email_address: (e) => {
    return !isEmpty(e) && isEmail(e) ? e : null;
  },
  first_name: (e) => {
    return isString(e) && !isEmpty(e) ? capitalize(trim(deburr(e))) : null;
  },
  last_name: (e) => {
    return isString(e) && !isEmpty(e) ? capitalize(trim(deburr(e))) : null;
  },
  address_1: (e) => {
    return isString(e) && !isEmpty(e) ? deburr(e) : null;
  },
  city: (e) => {
    return isString(e) && !isEmpty(e) ? e : null;
  },
  state: (e) => {
    return !isEmpty(e) && isLength(e, { min: 2, max: 2 })
      ? e.toUpperCase()
      : null;
  },
  zip_code: (e) => {
    let str = e.toString();

    return !isEmpty(str) &&
      isLength(str, { min: 5, max: 5 }) &&
      isNumeric(str, { no_symbols: true })
      ? str
      : null;
  },
  birth_month: (e) => {
    let str = e.toString();

    if (isEmpty(str) || !isLength(str, { min: 1, max: 2 }) || !isNumeric(str)) {
      return;
    }

    return str.length === 1 ? padStart(e, 2, 0) : e.toString();
  },
  birth_day: (e) => {
    let str = e.toString();

    if (isEmpty(str) || !isLength(str, { min: 1, max: 2 }) || !isNumeric(str)) {
      return;
    }

    return str.length === 1 ? padStart(e, 2, 0) : e.toString();
  },
  birth_year: (e) => {
    let str = e.toString();

    return !isEmpty(str) && isLength(str, { min: 4, max: 4 }) && isNumeric(str)
      ? e.toString()
      : null;
  },
  gender: (e) => {
    return !isEmpty(e) && isLength(e, { min: 1, max: 1 }) ? e : null;
  },
  phone_number: (e) => {
    let str = e.toString().replace(/[^0-9]/g, '');

    if (isEmpty(str)) {
      return '';
    }

    if (
      !isNumeric(str, { no_symbols: true }) ||
      !isMobilePhone(str, ['en-US'])
    ) {
      return;
    }

    if (str.length === 11) {
      str = str[0] === '1' ? str.substring(1) : str;
    }

    if (!isLength(str, { min: 10, max: 10 })) {
      return;
    }

    return parseInt(str);
  },
  VisitIndex: (e) => {
    let str = e.toString();

    return !isEmpty(str) && isNumeric(str, { no_symbols: true })
      ? parseInt(e)
      : 1;
  },
};

export default class Profile {
  constructor() {
    const self = this;
    Object.assign(
      this,
      Object.keys(schema).reduce((obj, key) => {
        obj[key] = key === 'VisitIndex' ? 1 : null;
        return obj;
      }, {}),
    );

    return new Proxy(this, {
      ownKeys(target) {
        return Object.keys(target);
      },
      set(target, prop, val, receiver) {
        return Reflect.set(target, prop, schema[prop](val) ?? null, receiver);
      },
      get(target, prop, receiver) {
        return prop === 'target' ? target : Reflect.get(target, prop, receiver);
      },
    });
  }

  values() {
    return Object.create(
      Object.getPrototypeOf(this),
      Object.getOwnPropertyDescriptors(this),
    );
  }

  updatePanelByFieldName(name, value) {
    const panel = window.sooper_panel.controller.getPanelByFieldName(name);

    if (panel === false) {
      return;
    }

    panel.value = value;
  }

  update(obj) {
    const profile = this.values();
    for (let key of Object.keys(profile)) {
      if (!Object.keys(obj).includes(key)) {
        continue;
      }

      if (
        window.sooper_panel.props.keep_pop &&
        this[key] !== null &&
        this[key].toString().length !== 0 &&
        obj[key] !== null &&
        obj[key].toString().length !== 0
      ) {
        continue;
      }

      if (key === 'gender' && obj[key] === false) {
        continue;
      }

      this[key] = obj[key];
      this.updatePanelByFieldName(key, obj[key]);
    }
  }
}
